import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Transition } from '@headlessui/react';
import PushNotifications from 'Components/Partials/PushNotifications';

import { User } from 'Services';
import { asset } from 'Services/BaseHelpers';
import { RemoteControl } from "Components/MainStage";
import AdminGroupSelect from "Components/Partials/AdminGroupSelect";

class Header extends React.Component {
    /**
     * @var state
     * @type {{showMenu: boolean}}
     */
    state = {
        showMenu: false,
    };

    /**
     * @method handleToggleShowMenu
     */
    handleToggleShowMenu = () => {
        const showMenu = !this.state.showMenu;

        this.setState({
            showMenu,
        }, () => {
            document.body.style.overflowY = showMenu ? 'hidden' : 'visible';
        });
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        return (
            <React.Fragment>
                {window.base.features.allow_push_notifications && <PushNotifications />}

                <nav className="w-full bg-white py-5 flex justify-between">
                    <div className="sm:w-1/12 flex">
                        <div
                            onClick={this.handleToggleShowMenu}
                            className="flex-col text-center ml-4 flex justify-center cursor-pointer"
                        >
                            <FontAwesomeIcon icon={faBars} size="lg" />
                        </div>

                        {/*<img
                            src={asset('/images/speed-make-waves.png')}
                            className="w-20 h-20 ml-4 hidden sm:block"
                        />*/}

                        {/*<span className="text-app-red font-bold my-auto ml-20">*/}
                        {/*    All in*/}
                        {/*</span>*/}
                    </div>
                    <div className="w-full xl:w-11/12">
                        <Link className="w-36 block mx-auto" to="/">
                            <img src={asset('/images/logo.png')} alt="Speedo" className="w-36 mx-auto" />
                        </Link>
                    </div>

                    <div className="sm:w-1/12 hidden xl:flex justify-end pr-4">
{/*                        <Link
                            to="/"
                            className={
                                'flex-col text-center transition duration-200 transform hover:scale-110 flex justify-center uppercase sm:mr-4  '
                            }
                        >
                             <span className={
                                 'uppercase font-gilroy text-xs bg-white rounded-full rounded-full px-5 py-2 text-app-red font-bold'
                             }>
                                HOME
                            </span>
                        </Link>*/}

                        <div className="flex flex-col sm:flex-row">
                            <Link to="/logout" className={
                                'flex-col text-center transition duration-200 transform hover:scale-110 flex justify-center uppercase pl-3'
                            }>
                                <span className={
                                    'uppercase font-gilroy text-xs bg-app-red rounded-full px-5 py-2 text-white font-bold'
                                }>
                                    Logout
                                </span>
                            </Link>
                        </div>
                    </div>
                </nav>

                {this.renderMobileMenu()}
            </React.Fragment>
        );
    }

    /**
     * @method renderMobileMenu
     * @return {JSX.Element}
     */
    renderMobileMenu = () => {
        const {
            showMenu,
            countdown,
        } = this.state;

        return (
            <Transition
                show={showMenu}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                className="z-50"
            >
                <div className="fixed bottom-0 left-0 right-0 bg-app-red z-50 p-6 overflow-y-auto" style={{
                    height: `calc(100vh - 90px)`,
                }}>
                    <div className="w-full md:w-1/2 lg:w-1/3 text-center mx-auto">
                        <div className="p-4">
                            {this.renderMobileButton('Home', '/')}
                            {this.renderMobileButton('My Profile', User.data.attending === null ? '/profile' : '/settings/profile')}
                            {this.renderMobileButton('Networking', '/networking')}


                            {/*{this.renderMobileButton('Agenda', '/agenda')}*/}
                            {/*{ this.renderMobileButton('Main Stage', '/main-stage')}*/}

                           {/* {this.renderMobileButton('Agenda', '/agenda')}
                            { this.renderMobileButton('Main Stage', '/main-stage')}
                            {this.renderMobileButton('Networking', '/networking')}
                            {this.renderMobileButton('On-Demand', '/on-demand')}
                            {this.renderMobileButton('Brand Marketing', '/brand-marketing')}*/}
{/*
                            {this.renderMobileButton('Register', '/profile')}
*/}

                            {process.env.MIX_APP_PHASE == 2  &&
                                <>
                                    {this.renderMobileButton('Agenda', '/agenda')}
                                    {this.renderMobileButton('Gallery', '/celebration-wall')}
                                    {/*{this.renderMobileButton('Product Showcase', '/product-showcase')}*/}
                                    {/*{this.renderMobileButton('Main Stage', '/main-stage')}*/}
                                    {this.renderMobileButton('Networking', '/networking')}
                                    {/*{User.data.timezone !== 'Virtual' && (*/}
                                    {/*    <RemoteControl />*/}
                                    {/*)}*/}
                                </>
                            }
                            {this.renderMobileButton('FAQs', '/faq')}
                            {this.renderMobileButton('Logout', '/logout')}
                        </div>

                    </div>
                </div>
            </Transition>
        );
    };

    /**
     * @method renderMobileButton
     * @param {string} display
     * @param {string} to
     * @return {JSX.Element}
     */
    renderMobileButton = (display, to) => {
        return (
            <Link
                className="text-white my-4 font-gilroy md:text-lg uppercase flex items-center transition duration-200 hover:opacity-50"
                to={to}
                onClick={() => document.body.style.overflowY = 'visible'}
            >
                {display}
            </Link>
        );
    };
}

export default withRouter(Header);
